import PublisherActions from '../../../../actions/PublisherActions';
import query from '../../../../helpers/query';
import { removeParams } from '../helpers';
import store from "../../../../stores/redux";

export const actions = {
    getFinanceOperations(state) {
        let params = {
        ...query.parseToSend(state),
        ...removeParams()
        };

        PublisherActions.getFinanceOperations(params);
    },

    getCurrenciesList() {
        let list = [];
        const currenciesList = store.getState().currency.list;

        if (currenciesList.length) {
            currenciesList.map((element) => {
                if(element.supported) {
                    list.push({
                        value: element.title,
                        title: element.title
                    });
                }
            });
        }

        return list;
    },
};